/**
 * @generated SignedSource<<b39b13755b62ddaa8494219261ba88a0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type NotificationChannel = "EMAIL" | "PUSH" | "SMS";
export type NotificationsInnerQuery$variables = Record<PropertyKey, never>;
export type NotificationsInnerQuery$data = {
  readonly session: {
    readonly user: {
      readonly id: string;
      readonly notificationPreferencesChannels?: {
        readonly requestedTimeAvailable: ReadonlyArray<NotificationChannel | null | undefined>;
      };
    } | null | undefined;
  } | null | undefined;
};
export type NotificationsInnerQuery = {
  response: NotificationsInnerQuery$data;
  variables: NotificationsInnerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NotificationPreferencesChannels",
      "kind": "LinkedField",
      "name": "notificationPreferencesChannels",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requestedTimeAvailable",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MemberUser",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationsInnerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "NotificationsInnerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v0/*: any*/),
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4087417ffa0a92154414604424161367",
    "id": null,
    "metadata": {},
    "name": "NotificationsInnerQuery",
    "operationKind": "query",
    "text": "query NotificationsInnerQuery {\n  session {\n    user {\n      __typename\n      id\n      ... on MemberUser {\n        notificationPreferencesChannels {\n          requestedTimeAvailable\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0d7769534baa04750c21348aa4d0bebf";

export default node;
